(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxy-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.boxy-home').forEach((section) => {
      const heroCarousel = section.querySelector('[data-boxy-hero-carousel]');
      const heroTabs = Array.from(section.querySelectorAll('[data-hero-tab]'));
      const heroSlides = Array.from(section.querySelectorAll('.boxy-home__hero-slide'));

      if (heroCarousel && heroTabs.length === heroSlides.length) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let autoTimer;
        let autoStartedAt = 0;
        let autoRemaining = 7000;
        let autoComplete = reducedMotion.matches;
        let pointerHovering = false;

        const setHeroState = (index) => {
          heroTabs.forEach((tab, tabIndex) => {
            const selected = tabIndex === index;
            tab.setAttribute('aria-selected', String(selected));
            if (selected) {
              tab.removeAttribute('tabindex');
            } else {
              tab.setAttribute('tabindex', '-1');
            }
          });

          heroSlides.forEach((slide, slideIndex) => {
            slide.inert = slideIndex !== index;
          });
        };

        const pauseAutoAdvance = () => {
          if (!autoTimer) return;
          window.clearTimeout(autoTimer);
          autoTimer = undefined;
          autoRemaining = Math.max(0, autoRemaining - (Date.now() - autoStartedAt));
        };

        const stopAutoAdvance = () => {
          pauseAutoAdvance();
          autoComplete = true;
        };

        const scheduleAutoAdvance = () => {
          if (autoComplete || autoTimer || pointerHovering || document.hidden || reducedMotion.matches) return;

          autoStartedAt = Date.now();
          autoTimer = window.setTimeout(() => {
            autoTimer = undefined;
            autoComplete = true;

            if (heroCarousel.current === 0 && typeof heroCarousel.select === 'function') {
              heroCarousel.select(1);
            }
          }, autoRemaining);
        };

        const selectHeroFromKeyboard = (index, event) => {
          stopAutoAdvance();
          if (typeof heroCarousel.select === 'function') {
            heroCarousel.select(index, event);
          }
          heroTabs[index]?.focus();
        };

        setHeroState(0);

        heroCarousel.addEventListener('slideshow:select', (event) => {
          const index = Number(event.detail?.index || 0);
          setHeroState(index);
          if (event.detail?.userInitiated) stopAutoAdvance();
        });

        heroCarousel.addEventListener('pointerdown', stopAutoAdvance, { passive: true });
        heroCarousel.addEventListener('focusin', stopAutoAdvance);
        heroCarousel.addEventListener('keydown', stopAutoAdvance);
        heroCarousel.addEventListener('mouseenter', () => {
          pointerHovering = true;
          pauseAutoAdvance();
        });
        heroCarousel.addEventListener('mouseleave', () => {
          pointerHovering = false;
          scheduleAutoAdvance();
        });

        heroTabs.forEach((tab, index) => {
          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;

            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              nextIndex = index === heroTabs.length - 1 ? 0 : index + 1;
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              nextIndex = index === 0 ? heroTabs.length - 1 : index - 1;
            } else if (event.key === 'Home') {
              nextIndex = 0;
            } else if (event.key === 'End') {
              nextIndex = heroTabs.length - 1;
            } else {
              return;
            }

            event.preventDefault();
            selectHeroFromKeyboard(nextIndex, event);
          });
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pauseAutoAdvance();
          } else {
            scheduleAutoAdvance();
          }
        });

        reducedMotion.addEventListener('change', (event) => {
          if (event.matches) {
            stopAutoAdvance();
          }
        });

        customElements.whenDefined('slideshow-component').then(scheduleAutoAdvance);
      }

      const roomButtons = Array.from(section.querySelectorAll('[data-room-tab]'));
      const roomPanels = Array.from(section.querySelectorAll('[data-room-panel]'));

      const setRoom = (button, shouldFocus = false) => {
        if (!button) return;

        const panelId = button.getAttribute('aria-controls');

        roomButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
          item.setAttribute('tabindex', '-1');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        button.removeAttribute('tabindex');

        roomPanels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });

        if (shouldFocus) {
          button.focus();
        }
      };

      roomButtons.forEach((button, index) => {
        button.addEventListener('click', () => setRoom(button));
        button.addEventListener('keydown', (event) => {
          const lastIndex = roomButtons.length - 1;
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = index === lastIndex ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = index === 0 ? lastIndex : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = lastIndex;
          } else {
            return;
          }

          event.preventDefault();
          setRoom(roomButtons[nextIndex], true);
        });
      });

      const modePanel = section.querySelector('[data-mode-panel]');
      const modeImage = section.querySelector('.boxy-home__mode-image');
      const modeText = section.querySelector('[data-mode-text]');
      const modeButtons = Array.from(section.querySelectorAll('[data-mode-tab]'));

      const setMode = (button, shouldFocus = false) => {
        if (!button) return;

        const mode = {
          src: button.dataset.modeSrc,
          alt: button.dataset.modeAlt,
          text: button.dataset.modeCopy
        };

        if (!mode.src) return;

        modeButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
          item.setAttribute('tabindex', '-1');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        button.removeAttribute('tabindex');

        if (modePanel && button.id) {
          modePanel.setAttribute('aria-labelledby', button.id);
        }

        if (modeImage) {
          modeImage.removeAttribute('srcset');
          modeImage.removeAttribute('sizes');
          modeImage.src = mode.src;
          modeImage.alt = mode.alt;
        }

        if (modeText) {
          modeText.textContent = mode.text;
        }

        if (shouldFocus) {
          button.focus();
        }
      };

      modeButtons.forEach((button, index) => {
        button.addEventListener('click', () => setMode(button));
        button.addEventListener('keydown', (event) => {
          const lastIndex = modeButtons.length - 1;
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = index === lastIndex ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = index === 0 ? lastIndex : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = lastIndex;
          } else {
            return;
          }

          event.preventDefault();
          setMode(modeButtons[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxy-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.boxy-product-landing');

    sections.forEach((section) => {
      const radios = section.querySelectorAll('[data-variant-radio]');
      const price = section.querySelector('[data-variant-price]');
      const comparePrice = section.querySelector('[data-variant-compare-price]');
      const saveBadge = section.querySelector('[data-variant-save]');
      const status = section.querySelector('[data-variant-status]');
      const button = section.querySelector('[data-add-button]');
      const dynamicCheckout = section.querySelector('[data-dynamic-checkout]');
      const mainImage = section.querySelector('.boxy-product-landing__hero-image');
      const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');

      const applyGalleryImage = (thumb) => {
        if (!mainImage) {
          return;
        }

        const update = () => {
          mainImage.removeAttribute('srcset');
          mainImage.src = thumb.dataset.gallerySrc;

          if (thumb.dataset.galleryAlt) {
            mainImage.alt = thumb.dataset.galleryAlt;
          }

          galleryThumbs.forEach((item) => item.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
          return;
        }

        update();
      };

      const applyVariant = (radio) => {
        const update = () => {
          if (price) {
            price.textContent = radio.dataset.price;
          }

          const onSale = radio.dataset.onSale === 'true';

          if (comparePrice) {
            comparePrice.textContent = radio.dataset.comparePrice || '';
            comparePrice.hidden = !onSale;
          }

          if (saveBadge) {
            saveBadge.textContent = radio.dataset.saveText || '';
            saveBadge.hidden = !onSale;
          }

          if (status) {
            status.textContent = radio.dataset.status;
          }

          if (button) {
            const ready = radio.dataset.ready === 'true';
            const preorder = radio.dataset.preorder === 'true';
            button.disabled = !ready;
            button.textContent = ready ? (preorder ? 'Pre-order Now' : 'Add to cart') : 'Unavailable online';

            if (dynamicCheckout) {
              dynamicCheckout.hidden = !ready;
            }
          }
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
          return;
        }

        update();
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', () => applyVariant(radio));
      });

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => applyGalleryImage(thumb));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const skippedSelector = '[data-widget], [data-calculator], .widget, .calculator, .shopify-app-block, iframe';

    const slugify = (text) => text.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';

    const initToc = (root) => {
      root.querySelectorAll('[data-boxy-article]').forEach((article) => {
        const toc = article.querySelector('[data-boxy-toc]');
        const list = article.querySelector('[data-boxy-toc-list]');
        const body = article.querySelector('.blog-post-content');

        if (!toc || !list || !body) return;

        list.innerHTML = '';
        const seen = new Map();
        const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => !heading.closest(skippedSelector));

        if (!headings.length) {
          toc.hidden = true;
          return;
        }

        headings.forEach((heading) => {
          const base = slugify(heading.textContent || '');
          const count = seen.get(base) || 0;
          seen.set(base, count + 1);
          const id = count ? `${base}-${count + 1}` : base;

          if (!heading.id) heading.id = id;

          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.appendChild(link);
          list.appendChild(item);
        });

        toc.hidden = false;
      });
    };

    document.addEventListener('DOMContentLoaded', () => initToc(document));
    document.addEventListener('shopify:section:load', (event) => initToc(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
